<div class="search-block_item">
  <ng-content></ng-content>
</div>
